import styled, { css } from 'styled-components';

import { Card } from "../Card";

import { ShimmerEffect as Shimmer } from "../ShimmerEffect";

export const Container = /*#__PURE__*/styled(Card).withConfig({ displayName: "ShimmingCardstyles__Container", componentId: "sc-48l6tm-0" })(["position:relative;overflow:hidden;padding:0px;", " height:", ";"],




({ loading }) =>
loading ?
css(["border-width:0px;padding:2px;"]) :



'',

({ height }) => typeof height === 'number' ? `${height}px` : 'auto');


export const Content = /*#__PURE__*/styled.div.withConfig({ displayName: "ShimmingCardstyles__Content", componentId: "sc-48l6tm-1" })(["padding:16px;transition:opacity 0.3s cubic-bezier(0.4,0,0.2,1);opacity:", ";"],


(props) => props.opacity);


export const ShimmerEffect = /*#__PURE__*/styled(Shimmer).withConfig({ displayName: "ShimmingCardstyles__ShimmerEffect", componentId: "sc-48l6tm-2" })(["border-radius:8px;"]);